import Link from "next/link";

import styles from "./ChatMenuItem.module.scss";

interface ChatMenuItemProps {
  iconSrc: string;
  text: string;
  href?: string;
}

const ChatMenuItem = ({ iconSrc, text, href = "" }: ChatMenuItemProps) => {
  return (
    <Link className={styles.root} href={href}>
      <img className={styles.icon} src={iconSrc} alt="" />
      <p className={styles.text}>{text}</p>
    </Link>
  );
};

export default ChatMenuItem;
